import React, { useState } from "react";

const Oneperson = () => {

  const [openSection, setOpenSection] = useState(null);
  
    const toggleSection = (section) => {
      setOpenSection(openSection === section ? null : section);
    };

  
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  return (
    <div className="p-8 bg-gray-100">
      {/* Title Section */}
      <h1 className="text-3xl font-bold text-center mb-6">
        One Person Company Registration
      </h1>
      <p className="text-gray-700 mb-6 text-justify text-center">
        Pursuant to Section 2(62) of the Companies Act, a one-person company
        (OPC) is legally defined as a business entity comprising only one
        individual as a member, said member being either a subscriber to the
        company’s Memorandum of Association (MOA) or a shareholder.
      </p>
      <p className="text-gray-700 mb-6 text-justify text-center">
      The One Person Company (OPC) registration represents a novel approach to business incorporation, mitigating constraints related to resources, time, and the necessity of multiple partners. This structure facilitates the incorporation of micro-businesses and enables individuals to realize their entrepreneurial ambitions.
      </p>
      <p className="text-gray-700 mb-6 text-justify text-center">
      The One Person Company (OPC) structure, registered pursuant to Section 2(62) of the Companies Act, 2013, may be conceptualized as a confluence of the traditional company and the sole proprietorship. The absence of complexities inherent in partnerships, coupled with the advantage of limited liability, serves as a significant impetus for OPC incorporation.</p>


<div className="space-y-4 mx-10 lg:mx-40">
        <div
          className={`border rounded-lg ${
            openSection === 1 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(1)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            1. Benefits Of One Person Company Registration
            <span>{openSection === 1 ? "-" : "+"}</span>
          </button>
          {openSection === 1 && (
              <ul className="list-disc pl-5 mt-2 bg-white  text-gray-700">
              <li className="font-bold">Limited Liability:</li> This is a major advantage. In an OPC, the owner's personal assets are separate from the company's liabilities. This means that if the company incurs debts or faces legal issues, the owner's personal assets are generally protected. 
              <li className="font-bold">Ease of Incorporation:</li> Setting up an OPC is relatively straightforward compared to other business structures like private limited companies. The process involves fewer compliances and paperwork.
              <li className="font-bold">Single Person Control:</li> As the sole shareholder and director, you have complete control over the company's decision-making process.
              <li className="font-bold">Separate Legal Entity:</li> An OPC is recognized as a separate legal entity from its owner. This provides a sense of professionalism and credibility, especially when dealing with clients, vendors, or other businesses.
              <li className="font-bold">Tax Benefits:</li> OPCs can enjoy certain tax benefits, such as lower tax rates compared to other business structures.  
              <li className="font-bold">Flexibility:</li> OPCs offer flexibility in terms of growth. If the business expands, it can be converted into a private limited company.
              <li>No requirement of minimum capital contribution</li>
              <li>Compulsory Audit is required only when the Contribution exceeds 25 lakhs or the Annual Turnover exceeds 40 Lakhs.</li>
            </ul>
          )}
        </div>

        {/* Section 1 */}
        <div
          className={`border rounded-lg ${
            openSection === 2 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(2)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
             2. Documents Required
            <span>{openSection === 2 ? "-" : "+"}</span>
          </button>
          {openSection === 2 && (
              <ul className="list-disc pl-5 mt-2   bg-white text-gray-700">
              <li className="font-bold">PAN Card:</li>Self-attested PAN Card of Member and Directors.
              <li className="font-bold">
                Identity Proof of Directors:</li> Self-attested ID Proof (Valid Passport,
                Voter ID, Aadhaar Card, or Valid Driving License).
            
              <li className="font-bold">
                Address Proof of Directors:</li> Self-attested Address Proof (Bank
                Statement, Electricity Bill, Telephone Bill, or Mobile Bill).
              <li className="font-bold">Passport Size Photos:</li> 2 recent passport-size colored photos.
              <li className="font-bold">
                Business Address Proof:</li>NOC from the property owner and utility bill
                (Electricity Bill or Telephone Bill).
              <li>Email IDs and contact numbers of all members and directors.</li>
            </ul>
          )}
        </div>
        </div>

      {/* Get in Touch Section */}
      <div className="bg-white shadow-md rounded-lg p-4 mt-6">
        <h2 className="text-lg font-semibold mb-2 ">Get in touch</h2>
        <p className="text-gray-700 mb-4 ">
          If you have any queries or questions, please reach out to us by
          clicking on the contact button and filling out the form.
        </p>
        <div className="flex  space-x-4">
          <button onClick={handleAppointmentClick} className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600">
            Make Appointment
          </button>
          <button className="bg-[#005A8C] text-white px-4 py-2 rounded hover:bg-blue-600">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default Oneperson;
